@if (reportTemplates$ | async; as res) {
  <article class="content-container">
    <div class="report-section report-section--search">
      <mds-search-bar
        [placeholder]="'Search for a template or a report kind...'"
        [hideEnterButton]="true"
        [theme]="'light'"
        (textChange)="onSearchTextChange($event)"
      ></mds-search-bar>
      <mds-dropdown-menu
        [iconPrefix]="'sort'"
        [options]="filterCategoryOptions"
        [formControl]="filterCategory"
      ></mds-dropdown-menu>
    </div>
    @if (allSavedReports.length) {
      <section class="report-section">
        <div class="report-section__header">
          <h2>My templates</h2>
          <mds-dropdown-menu
            [iconPrefix]="'sort'"
            [helperTextPre]="'Sort by'"
            [options]="sortingDirectionOptions"
            [formControl]="sortDirectionSaved"
          ></mds-dropdown-menu>
        </div>
        <ng-template
          *ngTemplateOutlet="tplReports; context: { $implicit: res.savedReports, isTemplate: true }"
        ></ng-template>
        @if ((searchText || filterCategory.value[0].text !== 'All') && !res.savedReports.length) {
          <ng-template *ngTemplateOutlet="tplNoResults"></ng-template>
        }
      </section>
    }
    <section class="report-section">
      <div class="report-section__header">
        <h2>All reports</h2>
        <mds-dropdown-menu
          [iconPrefix]="'sort'"
          [helperTextPre]="'Sort by'"
          [options]="sortingDirectionOptions"
          [formControl]="sortDirectionAll"
        ></mds-dropdown-menu>
      </div>
      @for (group of res.allReports; track group) {
        <div class="report-group">
          <h6>{{ group.letter }}</h6>
          <ng-template
            *ngTemplateOutlet="tplReports; context: { $implicit: group.reports, isTemplate: false }"
          ></ng-template>
        </div>
      }
      @if (searchText && !res.allReports) {
        <ng-template *ngTemplateOutlet="tplNoResults"></ng-template>
      }
    </section>
  </article>
}

<ng-template #tplReports let-reports let-isTemplate="isTemplate">
  @if (reports.length) {
    <div class="report-group__cards" data-testid="report-landing-cards">
      @for (report of reports; track report) {
        <div>
          <a
            [attr.data-testid]="'report-landing-card-' + report.rid"
            [attr.aria-label]="report.title"
            (click)="$event.stopPropagation()"
            [routerLink]="getReportLink(isTemplate, report).path"
            [queryParams]="getReportLink(isTemplate, report).queryParams"
            style="text-decoration: none"
            >
            <mds-template-card
              [inlineView]="true"
              [title]="report.title"
              [description]="report.description"
              [icon]="report.icon"
              [tag]="report.tag"
              [menuOptions]="report.menuOptions"
              (menuOptionClicked)="onMenuOptionClicked($event, report)"
            ></mds-template-card>
          </a>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #tplNoResults>
  <div class="no-content">
    <span>No results found. please try another search term.</span>
  </div>
</ng-template>

<ng-template #deleteReportDialogActions>
  <mds-button role="button" [type]="'secondary'" (click)="deleteReportDialogRef.close()" class="dialog-button-spacer">
    Cancel
  </mds-button>
  <mds-button role="button" [type]="'warn'" (click)="deleteReport()">Delete</mds-button>
</ng-template>

<ng-template #renameReportDialogBody>
  <div class="input-container">
    <label for="new-name">Template name</label>
    <input id="new-name" class="input" type="text" [(ngModel)]="newReportName" placeholder="New template name" />
  </div>
</ng-template>

<ng-template #renameReportDialogActions>
  <mds-button role="button" [type]="'secondary'" (click)="renameReportDialogRef.close()" class="dialog-button-spacer">
    Cancel
  </mds-button>
  <mds-button role="button" [type]="'primary'" (click)="renameReport()">Rename</mds-button>
</ng-template>
